<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-col h-full">
    <div class="flex justify-end items-center mx-2 mb-1 shrink-0">
      <span class="text-sm text-gray-500 mr-1">Min days for new bin</span>
      <i class="pi pi-info-circle text-blue-500 cursor-pointer" (click)="showMinDaysInfo()"></i>
    </div>
    <app-ag-grid [gridOptions]="sfGridOptions" [rowData]="shipFrequencies" [hasFooter]="false" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2 mt-3">
    <button [disabled]="!hasChanges()" (click)="ok()" pButton type="button" class="p-button-raised">Ok</button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
